import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.neutral.lightest,
  },
  count: {
    color: theme.palette.neutral.medium,
    marginRight: theme.spacing(2),
  },
  error: {
    color: theme.palette.error.main,
  },
});

function TextArea({ classes, charLimit, numRows, title, onChange, value, outlined, color }) {
  const showCount = (
    <Box display="flex" justifyContent="flex-end" mt={1}>
      <Typography
        variant="caption"
        className={`
          ${classes.count}
          ${charLimit === value.length ? classes.error : ''}
        `}
      >
        {`${value.length >= 0 ? charLimit - value.length : 0} Characters left`}
      </Typography>
    </Box>
  );
  return (
    <>
      <Box display="inline-flex" flexDirection="column" width="100%">
        <TextField
          multiline
          rows={numRows}
          placeholder={title}
          variant={outlined ? 'outlined' : 'standard'}
          onChange={e => onChange(e.target.value)}
          fullWidth
          inputProps={{
            maxLength: charLimit,
            style: {
              fontSize: '1rem',
              lineHeight: 1.25,
            },
          }}
          classes={{ root: classes.root }}
          value={value || ''}
          color={color}
        />
        {showCount}
      </Box>
    </>
  );
}

TextArea.propTypes = {
  classes: PropTypes.shape({
    count: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
  }).isRequired,
  charLimit: PropTypes.number,
  numRows: PropTypes.number,
  value: PropTypes.string,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  outlined: PropTypes.bool,
  color: PropTypes.string,
};

TextArea.defaultProps = {
  charLimit: 3000,
  numRows: 4,
  value: '',
  outlined: true,
  color: 'primary',
};

export default withStyles(styles)(TextArea);
